module.exports = __webpack_public_path__ + "static/media/search.dd199233.svg";